import React from "react";
import ServicesLayout from "../../../layouts/Services.layout";

export const AccountDeletedPage: React.FC = () => {
  return (
    <ServicesLayout title="Your account has been deleted">
      <div className="text-base theme-text-secondary">We’ll miss you.</div>
    </ServicesLayout>
  );
};
